import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@user-portal/wikr-components';
import StarIcon from 'assets/img/webp/star.svg';

import Modal from 'components/Modal';
import { Cross, MoveBack } from 'components/Icon';

import * as S from './styled';

import { PauseSubscriptionModalProps } from './types';

const pauseDetails = [
    'subscription.pause.card.details1',
    'subscription.pause.card.details2',
    'subscription.pause.card.details3',
];

const PauseSubscriptionModal = ({
    onSubmit,
    onDiscard,
    onClose,
    onMoveBack,
    trackLoad,
    isPauseFlow,
}: PauseSubscriptionModalProps) => {
    const { t } = useTranslation();
    const headerTitle = isPauseFlow ? t('subscription.pause.modalTitle') : t('subscription.text.cancel');
    const showMoveBack = !isPauseFlow && !!onMoveBack;

    return (
        <Modal
            isOpen
            paddingY={0}
            paddingX={0}
            onClose={onClose}
            transparentOverlay={false}
            transparentBackground
            trackLoad={trackLoad}
        >
            <S.PauseModalContent data-locator="pauseOfferContainer">
                <S.ModalHeaderTitle>
                    {showMoveBack && (
                        <S.IconWrapper onClick={onMoveBack} data-locator="cancelSubscriptionModalBackButton">
                            <MoveBack />
                        </S.IconWrapper>
                    )}
                    <S.TitleText $isLeftButton={showMoveBack}>
                        <Text type="large-text" medium>
                            {headerTitle}
                        </Text>
                    </S.TitleText>
                    <S.IconWrapper onClick={onClose} data-locator="cancelSubscriptionModalCloseButton">
                        <Cross />
                    </S.IconWrapper>
                </S.ModalHeaderTitle>

                <Text type="h4" medium center bold mb={12}>
                    {t('subscription.pause.title')}
                </Text>
                <Text type="large-text" center mb={24}>
                    {t('subscription.pause.subTitle')}
                </Text>

                <S.PauseCard>
                    <S.CardHeader>
                        <Text center>{t('subscription.pause.card.header')}</Text>
                    </S.CardHeader>

                    <S.CardBody>
                        <Text type="h5" center mb={24}>
                            {t('subscription.pause.card.title')}
                        </Text>
                        <S.DetailsList>
                            {pauseDetails.map((details) => (
                                <li>
                                    <S.InfoBlock key={details}>
                                        <StarIcon />
                                        <Text>{t(details)}</Text>
                                    </S.InfoBlock>
                                </li>
                            ))}
                        </S.DetailsList>
                        <S.PauseButton dataLocator="pauseOfferPauseSubscriptionButton" onClick={onSubmit}>
                            {t('subscription.pause.text')}
                        </S.PauseButton>
                    </S.CardBody>
                </S.PauseCard>

                {!isPauseFlow && (
                    <S.ConfirmButton
                        dataLocator="pauseOfferCancelSubscriptionButton"
                        size="medium"
                        textColor="action-main"
                        onClick={onDiscard}
                    >
                        {t('subscription.text.cancel')}
                    </S.ConfirmButton>
                )}
            </S.PauseModalContent>
        </Modal>
    );
};

export default PauseSubscriptionModal;
